import {
  createClient,
  type Session,
  type SupabaseClient,
} from "@supabase/supabase-js";

type BootstrapConfig = {
  supabaseUrl: string;
  supabasePublishableKey: string;
};

let browserClient: SupabaseClient | null = null;

export function getBrowserSupabase(config: BootstrapConfig) {
  if (!browserClient) {
    browserClient = createClient(
      config.supabaseUrl,
      config.supabasePublishableKey,
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
        },
      }
    );
  }

  return browserClient;
}

export async function getInitialSession(config: BootstrapConfig) {
  const client = getBrowserSupabase(config);
  const { data, error } = await client.auth.getSession();
  if (error) {
    throw error;
  }
  return data.session satisfies Session | null;
}
